/**
 * SYM-6337. What to tell the customer when a Bring to Life clip fails.
 *
 * With the window open, its own error screen says it. After "Close and wait"
 * the window is gone, and a failure used to reach nobody: generation 25795
 * (24 Sep 2026) was refused by fal 21 seconds in and the page stayed silent,
 * while a clip that ARRIVES has always been announced with a toast. This is
 * the announcement for the other outcome.
 *
 * Returns null when the window is open, because the screen already says it.
 */
export interface BtlFailureNotice {
  title: string;
  description: string;
}

export const btlFailureNotice = (
  windowOpen: boolean,
  reason: string | null | undefined
): BtlFailureNotice | null => {
  if (windowOpen) return null;

  const why = (reason ?? '').trim();
  return {
    title: 'Your video clip could not be made',
    description:
      (why ? `${why} ` : '') +
      'Nothing was added to your ad. You can start Bring to Life again.',
  };
};
